import { Injectable, EventEmitter, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ELearningDashboardState } from '../Elearning-Models';
import { IAPIService } from './API-Service/IAPIService';

export abstract class IStateService{
  abstract setState(filter?: number, collapsed?: number, anchor?: number, teacher?: number): void;
  abstract saveState(): void;
  abstract stateEmitter: ReplaySubject<ELearningDashboardState>;
  abstract hasAnchorFeature(): boolean;
}
@Injectable({
  providedIn: 'root'
})
export class StateService implements IStateService {

  stateEmitter: ReplaySubject<ELearningDashboardState> = new ReplaySubject<ELearningDashboardState>();

  eLearningDashboardState: ELearningDashboardState = new ELearningDashboardState();

  lastStateChange: Date = new Date();
  sameStateAsLastSave: boolean = true;

  saveStateInterval: number = 10000;

  constructor(private APIService: IAPIService){
    setInterval(() => {
      let newTime = new Date();
      let timeDiff = newTime.getTime() - this.lastStateChange.getTime();
      if(timeDiff > this.saveStateInterval && !this.sameStateAsLastSave){
        this.saveState();
      }
    }, this.saveStateInterval);

    this.getState();
  }

  setState(filter?: number, collapsed?: number, anchor?: number, teacher?: number)
  {
    if(filter != null){
      this.eLearningDashboardState.StudentFilter = filter;
    }

    if(collapsed != null){
      let i = this.eLearningDashboardState.Collapsed.findIndex(item => item == collapsed);

      if(i == -1){
        this.eLearningDashboardState.Collapsed.push(collapsed);
      }
      else{
        this.eLearningDashboardState.Collapsed.splice(i, 1);
      }
    }

    if(anchor != null){
      this.eLearningDashboardState.Anchor = anchor;
    }
    
    if(teacher != null){
      this.eLearningDashboardState.TeacherID = teacher;
    }

    this.lastStateChange = new Date();
    this.sameStateAsLastSave = false;
  }

  saveState(){
      // call save state from api service
      this.APIService
      .SaveELearningDashboardState(this.eLearningDashboardState)
      .subscribe(result => {
        if(result)
        { 
          this.sameStateAsLastSave = true;
        }
      });
  }

  private getState(){
    this.APIService
    .GetELearningDashboardState()
    .subscribe(result => {
      if(result){
        let jsonResult = JSON.parse(result);
        let newResult = this.getStateFromJson(jsonResult);
        this.eLearningDashboardState.copyFromModel(newResult); 
      }
      else{
        this.eLearningDashboardState = new ELearningDashboardState();
      }
      this.stateEmitter.next(this.eLearningDashboardState);
    });
  }

  private getStateFromJson(jsonResult: any){
    let returnedState = new ELearningDashboardState();

    if(jsonResult.Collapsed){
      jsonResult.Collapsed.forEach(item => {
        returnedState.Collapsed.push(item);
      });
    }

    if(jsonResult.StudentFilter){
      returnedState.StudentFilter = jsonResult.StudentFilter;
    }

    if(jsonResult.Anchor){
      returnedState.Anchor = jsonResult.Anchor;
    }

    if(jsonResult.TeacherID){
      returnedState.TeacherID = jsonResult.TeacherID;
    }

    return returnedState;
  }

  hasAnchorFeature(){
    return true;
  }
    
}

